import * as React from "react";
let Logo ="password.png";

export default class PanelPassword extends React.Component <{}> {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  
  componentDidMount () {
		const node = document.querySelectorAll('button');
    node.forEach(element => {
    //  console.log(element);
      const item=element.querySelectorAll('span')
      if(item[0]!= undefined) if(item[0].innerHTML=="Next")item[0].innerHTML="Etape suivante";
      if(item[0]!= undefined) if(item[0].innerHTML=="Back")item[0].innerHTML="Etape précédente";
      if(item[0]!= undefined) if(item[0].innerHTML=="Submit")item[0].innerHTML="Envoyer";
     // console.log(item);
    });
    //const node2=node.querySelectorAll('button');
    
  }
  handleChange(e) {
    //console.log(e.target);
    this.props.onChange(e.target);
  }

  render() {
    return (
      <div style={{padding:'10px'}}>
        <h3>Dernière étape</h3>
        <p>Saisir un mot de passe</p>
        <div>
          <img height="250" src={Logo} /> 
        </div>
        <div style={{margin:'-20px 0 0 0'}}>
        <p>Entrez votre mot de passe</p>
        <input id="pswd1" type="password" onChange={this.handleChange} placeholder="Mot de passe"/>
        </div>
        <div style={{margin:'50px 0 0 0'}}>
        <p>Confirmez votre mot de passe</p>
        <input id='pswd2' type="password" onChange={this.handleChange} placeholder="Mot de passe"/>
        </div>
      </div>
    );
  }
}
